import Styled from 'styled-components'


export const Container = Styled.div`
`

export const H3 = Styled.h3`
`

export const DivBuscaled = Styled.div`
`
export const Filtering = Styled.div`
`
 
export const Passagem = Styled.div`
`

export const ConteudoDaPassagem = Styled.div`
`
export const Button = Styled.button`
`

export const Airplane = Styled.div`
`
export const AirTicketInstruction = Styled.div`
`
export const CheckboxContainer = Styled.div`
`

export const Radio = Styled.input`
`

export const Img = Styled.img`
`


export const Line = Styled.div`

`

export const Cidade = Styled.div`
`

export const Direto = Styled.div`
`

export const Rate = Styled.div`
`

export const ContainerRate = Styled.div`
`